var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#calendar-alt';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-calendar-alt';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?calendar-alt#calendar-alt';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?calendar-alt#view-calendar-alt';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 96 96',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };